/**
 * Convenciones de Posición de Campo y Yardaje en Flag Football 5v5 (M4)
 *
 * Contrato de coordenadas:
 * - Coordenada longitudinal 0 a 50 yardas entre líneas de gol (sin contar end zones).
 * - 0: Línea de gol propia.
 * - 1..24: "Propia X" (aumenta hacia el campo rival).
 * - 25: "Medio campo".
 * - 26..49: "Rival (50 - X)" (ej. 38 -> Rival 12, 45 -> Rival 5).
 * - 50: Línea de gol rival / Touchdown.
 * - Ganancia neta = posición final - posición inicial.
 */

export function formatFieldYard(yard: number | null | undefined): string {
  if (yard === null || yard === undefined || isNaN(yard)) {
    return 'N/D'
  }
  if (yard <= 0) return 'Propia 0 (Gol)'
  if (yard < 25) return `Propia ${yard}`
  if (yard === 25) return 'Medio campo'
  if (yard < 50) return `Rival ${50 - yard}`
  return 'Rival 0 (Gol / TD)'
}

export function calculateNetYards(
  startYard: number | null | undefined,
  endYard: number | null | undefined
): number | null {
  if (
    startYard === null ||
    startYard === undefined ||
    isNaN(startYard) ||
    endYard === null ||
    endYard === undefined ||
    isNaN(endYard)
  ) {
    return null
  }
  return endYard - startYard
}

export function formatNetYards(netYards: number | null | undefined): string {
  if (netYards === null || netYards === undefined || isNaN(netYards)) {
    return 'Pendiente / N/D'
  }
  if (netYards > 0) return `+${netYards} yd`
  if (netYards === 0) return '0 yd'
  return `${netYards} yd`
}
